import { nothing as e } from "lit";
import { classMap as t } from "lit/directives/class-map.js";
import { unsafeStatic as x, literal as $, html as s } from "lit/static-html.js";
import { getCustomElementSuffix as _ } from "../../api/custom-element-scope.js";
const u = $`dss-icon${x(_())}`, b = (a) => {
  var l, r, d, i;
  return s`
  <div class="dss-textarea ${t({
    "dss-textarea--invalid": a.invalid,
    "dss-textarea--auto-height": a.autoHeight,
    "dss-textarea--disabled": a.disabled,
    "dss-textarea--gap": a.maxLength || !!a.helpText || a.size !== "sm",
    "dss-textarea--gap-sm": a.size === "sm",
    "dss-textarea--required": a.required,
    "dss-textarea--empty-description": !a.maxLength && !a.helpText,
    [`dss-textarea--${a.size}`]: !!a.size
  })}">

    ${a.size === "sm" ? s`
        <div class="dss-textarea-label">
          <label class="dss-label" for="${a._getEffectiveId()}">${a.label}</label>
        </div>
      ` : e}

    <div class="dss-textarea__group ${t({
    "dss-textarea__group--focused": ((l = a._textarea) == null ? void 0 : l.value) || a.value || a._isTextareaFocused || a.placeholder,
    // 'dss-textarea__group--focused-visible': true,
    "dss-textarea__group--focused-visible": a._isGroupFocusedVisible,
    [`dss-textarea__group--${a.size}`]: !!a.size,
    "dss-textarea__group--has-label": !a.hideLabel && !!a.label,
    "dss-textarea__group--required": a.required,
    "dss-textarea__group--readOnly": a.readonly,
    "dss-textarea__group--read-only-empty": a.readonly && a.placeholder === "" && !((r = a._textarea) != null && r.value)
  })}">

      ${a.icon ? s`
          <${u} icon="${a.icon}" class="dss-textarea-icon"></${u}>
        ` : e}

      <div class="dss-textarea__content">
        ${a.size !== "sm" ? s`
            <label class="dss-label" for="${a._getEffectiveId()}">${a.label}</label>
          ` : e}
        <textarea
          class="dss-textarea"
          id="${a._getEffectiveId()}"
          rows=${a.rows ?? 3}
          wrap=${a.wrap ?? "soft"}
          .placeholder=${a.placeholder}
          .value=${a.value ?? ""} 
          ?disabled=${a.disabled}
          ?readonly=${a.readonly}
          ?required=${a.required}
          ?autofocus=${a.autofocus}
          spellcheck=${a.spellcheck ? "true" : "false"}
          autocorrect=${a.autocorrect ? "on" : "off"}
          autocomplete=${a.autocomplete}
          autocapitalize=${a.autocapitalize}
          minlength=${a.minLength ?? e}
          maxlength=${a.maxLength ?? e}
          inputmode=${a.inputmode ?? e}
          aria-label="${a.hideLabel ? a.label : e}"
          @input=${a._handleInput}
          @focusin=${a._handleFocus}
          @focusout=${a._handleFocusOut}
        ></textarea>
      </div>

    </div>

    ${a.helpText || a.maxLength ? s`
      <div class="dss-textarea__help">
        <div class="dss-textarea__description">
          ${a.helpText}
        </div>
        ${a.maxLength ? s`
            <span>${((i = (d = a._textarea) == null ? void 0 : d.value) == null ? void 0 : i.length) ?? 0}/${a.maxLength}</span>` : e}
      </div>
      ` : e}
  </div>
`;
};
export {
  b as template
};
//# sourceMappingURL=form-textarea.template.js.map
